import React from 'react';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  XIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";

import './Social.css';

interface Props extends Record<string, any> {
  title: string;
  shareUrl: string;
};

export default function SocialButton({ title="AvePoint", shareUrl="https://www.avepoint.com" }:Props) {
  return (
    <div className="social-container">
      {/* Linkedin */}
      <div className="social-network">
        <LinkedinShareButton url={shareUrl} className="social-network_share-button">
          <LinkedinIcon size={32} round={false} bgStyle={{ fill: 'white' }} iconFillColor="#54565A" />
        </LinkedinShareButton>
      </div>
      {/* Facebook */}
      <div className="social-network">
        <FacebookShareButton url={shareUrl} className="social-network_share-button">
          <FacebookIcon size={32} round={false} bgStyle={{ fill: 'white' }} iconFillColor="#54565A" />
        </FacebookShareButton>
      </div>
      {/* Twitter */}
      <div className="social-network">
        <TwitterShareButton url={shareUrl} title={title} className="social-network_share-button">
          <XIcon size={32} round={false} bgStyle={{ fill: 'white' }} iconFillColor="#54565A" />
        </TwitterShareButton>
      </div>
      {/* Email */}
      <div className="social-network">
        <EmailShareButton url={shareUrl} subject={title} body="body" className="social-network_share-button">
          <EmailIcon size={32} round={false} bgStyle={{ fill: 'white' }} iconFillColor="#54565A" />
        </EmailShareButton>
      </div>
      {/* Whatsapp */}
      <div className="social-network">
        <WhatsappShareButton url={shareUrl} title={title} separator=":: " className="social-network_share-button">
          <WhatsappIcon size={32} round={false} bgStyle={{ fill: 'white' }} iconFillColor="#54565A" />
        </WhatsappShareButton>
      </div>
    </div>
  );
}